<script setup>

const emit = defineEmits(['registerBarcodeScanDevice']);

const onClickRegister = () => {
  emit('registerBarcodeScanDevice');
}

</script>

<template>
  <div class="modal com_modal2 fade" id="addBarcodeScanDeviceConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1">バーコードスキャン機能を利用する場合は、利用開始ボタンを押してください。</h3>
          <p class="com_fs12 com_center1 com_color3 com_mgb0">※利用端末はユーザー管理画面で解除できます。<br>メニューボタン押して、ユーザー管理に移動してください。</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd1" data-bs-dismiss="modal" @click="onClickRegister">利用開始</button>
        </div>
      </div>
    </div>
  </div>
</template>